// extracted by mini-css-extract-plugin
export default {"title":"LabelName_title__Jxxx9"};